import { Component, Input } from '@angular/core';
import { Station } from '../../../../../../client/model/station';

@Component({
    selector: 'app-waiting-area-item',
    templateUrl: './waiting-area-item.component.html',
    styleUrls: ['./waiting-area-item.component.scss'],
    standalone: false
})
export class WaitingAreaItemComponent {

  @Input() station: Station;

  @Input() selected: boolean;
}
